import { render, staticRenderFns } from "./AlbumLegacySync.vue?vue&type=template&id=f9b5d9fc"
import script from "./AlbumLegacySync.vue?vue&type=script&lang=js"
export * from "./AlbumLegacySync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9b5d9fc')) {
      api.createRecord('f9b5d9fc', component.options)
    } else {
      api.reload('f9b5d9fc', component.options)
    }
    module.hot.accept("./AlbumLegacySync.vue?vue&type=template&id=f9b5d9fc", function () {
      api.rerender('f9b5d9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/AlbumLegacySync.vue"
export default component.exports